import React from "react";


import * as S from "./styles";
import isMobile from "~/hooks/isMobile";

export default function ParticipationInfo() {
  const mobile = isMobile();

  const desktopContent = [
    {
      title: "COMPRE",
      description: (
        <>
          <b>R$ 50</b>
          <br />
          em produtos participantes
        </>
      )
    },
    {
      title: "CADASTRE",
      description: (
        <>
          sua
          <br />
          <b>nota fiscal</b>
        </>
      )
    },
    {
      title: "POSTE",
      description: (
        <>
          um <b>vídeo</b>
          <br />
          do seu bebê
        </>
      )
    },
    {
      title: "COMPARTILHE",
      description: (
        <>
          Os bebês mais curtidos serão as <b>novas estrelas</b>
        </>
      )
    }
  ];

  const mobileContent = [
    {
      title: "COMPRE",
      description: (
        <>
          <b>R$ 50</b>
          <br />
          em produtos participantes
        </>
      )
    },
    {
      title: "CADASTRE",
      description: (
        <>
          sua <b>nota fiscal</b>
          <br />
          no site
        </>
      )
    },
    {
      title: "POSTE",
      description: (
        <>
          um <b>vídeo</b>
          <br />
          do seu bebê
          <br />
          no Instagram
        </>
      )
    },
    {
      title: "COMPARTILHE",
      description: (
        <>
          Os bebês mais curtidos serão as <b>novas estrelas</b>
        </>
      )
    }
  ];

  const content = mobile ? mobileContent : desktopContent;

  return (
    <S.ParticipationInfoHolder id="como-participar">
      <S.StyledHeadingContainer>
        <S.StyledHeadingLine />
        <S.StyledHeadingText>Veja como é fácil participar!</S.StyledHeadingText>
      </S.StyledHeadingContainer>

      <S.PromoCirclesContainer>
        {content.map((item, index) => (
          <S.PromoContainer key={index}>
            <div className="promo-circle promo-accent"></div>
            <div className="promo-circle promo-background">
              <div className="promo-text-main">{item.title}</div>
              <div className="promo-text-description">{item.description}</div>
            </div>
          </S.PromoContainer>
        ))}
      </S.PromoCirclesContainer>
    </S.ParticipationInfoHolder>
  );
}